import { render } from "./EnUnit3-4-game.vue?vue&type=template&id=02bd0f94&scoped=true"
import script from "./EnUnit3-4-game.vue?vue&type=script&lang=js"
export * from "./EnUnit3-4-game.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=02bd0f94&scoped=true&lang=css"
import "../assets/css/en/Unit3-4-game.css?vue&type=style&index=1&id=02bd0f94&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bd0f94"]])

export default __exports__